import { Injectable, signal, PLATFORM_ID, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable( { providedIn: 'root' } )
export class TrackingService {
    private readonly STORAGE_KEY = 'emp_tracking_uuid';

    private appConfig = inject( AppConfigService );

    trackingId: string | null = null;

    initialize(): Observable<boolean> {
        if ( this.appConfig.cli() ) {
            let uuid = localStorage.getItem( this.STORAGE_KEY );

            if ( !uuid ) {
                uuid = crypto.randomUUID();
                localStorage.setItem( this.STORAGE_KEY, uuid );
            }

            this.trackingId = uuid;
        } else {
            this.trackingId = 'SERVER-UUID';
        }

        return of( true );
    }
}

// Factory per app initializer
export function initializeTracking(): Observable<boolean> {
    const trackingService = inject(TrackingService);
    return trackingService.initialize();
}